import { getAvailableUserRoles } from '../../../../User/UserActions.js';

// A single panel holds every disclaimer displayed on top of the pages:
// each `disclaimers` item is one alert with its own audience & display period.
export default {
	type: 'panel',
	name: 'disclaimer',
	blocks: [
		{
			name: 'disclaimers',
			label: 'Disclaimers',
			type: 'mixed',
			blocks: [
				{
					name: 'content', // Message displayed in the alert
					label: 'Content',
					type: 'html',
					max: 1,
				},
				{
					name: 'action', // Optional call to action rendered as a button
					label: 'Action',
					type: 'link',
					max: 1,
				},
				{
					name: 'importance', // Bootstrap contextual color of the alert
					label: 'Importance',
					type: 'select',
					max: 1,
					options: ['danger', 'warning', 'info'],
				},
				{
					name: 'allowedRoles', // Empty means "displayed to everyone"
					label: 'Allowed roles',
					type: 'select',
					multiple: true,
					max: 1,
					options: getAvailableUserRoles(),
				},
				{
					name: 'dateFrom',
					label: 'Display from',
					type: 'date',
					max: 1,
				},
				{
					name: 'dateTo',
					label: 'Display until',
					type: 'date',
					max: 1,
				},
			],
		},
	],
};
